import React from 'react';

const Attach = ({
  width = 15,
  className = '',
}) => (
  <svg
    className={`svg-icon ${className || ''}`}
    width={width}
    height={width * 1.6}
    viewBox="0 0 15 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <path d="M14 3V16.5C14 20.0899 11.0899 23 7.5 23V23C3.91015 23 1 20.0899 1 16.5V5.5C1 3.01472 3.01472 1 5.5 1V1C7.98528 1 10 3.01472 10 5.5V15.5C10 16.8807 8.88071 18 7.5 18V18C6.11929 18 5 16.8807 5 15.5V6" stroke="black" strokeWidth="2" />
  </svg>
);

export default Attach;
